import { render } from "./CFMTemplateModal.vue?vue&type=template&id=4926b734&scoped=true"
import script from "./CFMTemplateModal.vue?vue&type=script&lang=js"
export * from "./CFMTemplateModal.vue?vue&type=script&lang=js"

import "./CFMTemplateModal.vue?vue&type=style&index=0&id=4926b734&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4926b734"]])

export default __exports__